export default __webpack_public_path__ + "static/media/files-instruction.ebc785aa.svg";